/**
 * @name salad
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkuNDk2IDEyYTIuNSAyLjUgMCAwMC4zOTktMi4yMTRBMiAyIDAgMDAyMC4zMiA2LjUgMiAyIDAgMDAxOSAzYTIgMiAwIDAwLTEuNS42OCAyIDIgMCAwMC0zLjI4Ny40MjQgMi41IDIuNSAwIDAwLTMuMTg5IDIuMDZBMyAzIDAgMDAxMiAxMmw0LTQiIC8+CiAgPHBhdGggZD0iTTQgMTJhMSAxIDAgMDAtLjk5IDEuMTMzQTkgOSAwIDAwMTIgMjFhOSA5IDAgMDA4Ljk5LTcuODY3QTEgMSAwIDAwMjAgMTJ6IiAvPgogIDxwYXRoIGQ9Ik03IDIxaDEwIiAvPgogIDxwYXRoIGQ9Ik05Ljg1IDYuOTA3QTMuNSAzLjUgMCAwMDUuMDUgMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/salad
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Salad: string = `
<svg
  class="lucide lucide-salad"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M19.496 12a2.5 2.5 0 00.399-2.214A2 2 0 0020.32 6.5 2 2 0 0019 3a2 2 0 00-1.5.68 2 2 0 00-3.287.424 2.5 2.5 0 00-3.189 2.06A3 3 0 0012 12l4-4" />
  <path d="M4 12a1 1 0 00-.99 1.133A9 9 0 0012 21a9 9 0 008.99-7.867A1 1 0 0020 12z" />
  <path d="M7 21h10" />
  <path d="M9.85 6.907A3.5 3.5 0 005.05 12" />
</svg>
`;

export default Salad;
